import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddcameradialogComponent } from '../addcameradialog/addcameradialog.component';
import { GmDashboardService } from '../gm-dashboard.service';
import { DragDropTransferService } from '../drag-drop-transfer.service';
import { InputAlertComponent } from '../../input-alert/input-alert.component';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs';


@Component({
  selector: 'app-addvideo',
  templateUrl: './addvideo.component.html',
  styleUrls: ['./addvideo.component.scss']
})
export class AddvideoComponent implements OnInit {
  @Output() dropped = new EventEmitter<any>();
  campusData: any[];
  buildingData: any;
  empid: any;
  cctvcameralist: any;
  payrollId: any;
  buildingid: any;
  buildingId: any;
  dialogRef1: MatDialogRef<AddcameradialogComponent, any>;
  subscription: any;
  droppedCameras: any;
  channelName: any;
  campusControl: any = new FormControl();
  buildingControl: any = new FormControl();
  filteredCampuses: any;
  filteredBuildings: any;
  constructor(private servies: GmDashboardService, @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog, public dialogRef: MatDialogRef<AddvideoComponent>, private dragDropService: DragDropTransferService) {
  }
  ngOnInit(): void {
    console.log("employeeid", this.data);
    this.empid = this.data.empId,
      this.payrollId = this.data.payrollId

    this.campuslist()
    this.servies.campusdashboard(this.payrollId).subscribe((res: any) => {
      this.campusData = res;
      this.filteredCampuses = this.campusControl.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.campusData, 'campusName'))
      );
      console.log("list", this.campusData);
    });



  }
  onItemDropped(item: any) {
    this.cctvcameralist.cameraDetails = this.cctvcameralist.cameraDetails.filter(
      (cam: any) => cam !== item
    );
    const channelDialog = this.dialog.open(InputAlertComponent, {
      width: '500px',
      height: '300px',
      data: 'channel Name'
    })
    channelDialog.afterClosed().subscribe((res: any) => {
      this.channelName = res;
      const data = {
        'buildingName': this.cctvcameralist.buildingName,
        'item': item,
        'channelName': this.channelName
      }
      this.dragDropService.sendDroppedItem(data);
    })

  }
  private Filter(value: string, list: any[], name: string): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].trim().toLocaleLowerCase().includes(searchValue));
    return filteredList;
  }

  onCampusSelect(event: any) {
    const selectedName = event.campusName;
    const selectedCampus = this.campusData.find((c: any) => c.campusName === selectedName);
    if (selectedCampus) {
      this.onCampusChange({ target: { value: selectedCampus.campusId } });
    }
  }
  campuslist() {
    // this.servies.getcampusdashboard().subscribe((res: any) => {
    //   this.campusData = res;
    //   console.log("list", this.campusData);
    // });
  }
  onCampusChange(event: any) {
    const selectedCampusId = event.campusId;
    if (selectedCampusId) {
      this.getBuilding(selectedCampusId);
    }
  }
  onbuilding(event: any) {
    this.buildingId = event.buildingId;
    if (this.buildingId) {
      this.getcctv(this.buildingId);
    }
  }
  getBuilding(selectedCampusId: any) {
    this.servies.getbuildingdashboard(selectedCampusId).subscribe((res: any) => {
      this.buildingData = res;
      this.filteredBuildings = this.buildingControl.valueChanges.pipe(
        startWith(''),
        map((value: any) => this.Filter(value, this.buildingData, 'buildingName'))
      );
      this.buildingid = this.buildingData.buildingId
      console.log("list", this.buildingData);
    })
  }
  getcctv(buildingId: any) {
    this.servies.getempyoleaddcamera(buildingId, this.empid).subscribe(res => {
      this.cctvcameralist = res
    })
  }
  openDialog(camera: any) {
    console.log('addVideo')
    console.log('ddd', camera)
    this.dialogRef1 = this.dialog.open(AddcameradialogComponent, {
      data: {
        camera: camera,
        empDetails: this.data,
        buildingName: this.cctvcameralist.buildingName
      },
      width: '90%', height: '90%',
    })
    this.dialogRef1.afterClosed().subscribe((value: any) => {
      this.servies.getempyoleaddcamera(this.buildingId, this.empid).subscribe(res => {
        this.cctvcameralist = res
      })
    })

  }
  onCameraDragStart(event: DragEvent, camera: any): void {
    // Pass the camera data as a string during drag
    const dragData = {
      camera,
      empDetails: this.data,
      buildingName: this.cctvcameralist.buildingName
    };

    event.dataTransfer?.setData('application/json', JSON.stringify(dragData));
    console.log(dragData);

  }
  employesid() {
    // const emp={
    //   payRollId:this.payrollId
    // }
    this.dialogRef.close()
  }
}
